import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Edit} from "@mui/icons-material";
import {ErrorMessage, Field, Form, Formik} from "formik";
import {Spinner} from "../index";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {getCitylist, getProviences, url} from "../../services/service";
import {toast} from "react-toastify";
import axios from "axios";

export default function EditPostCenterModal({info}) {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };



    const [provience, setProvience] = useState(false)
    const [selectedProvince, setSelectedProvince] = useState(false)


    const nav = useNavigate()


    // pending
    const [pending, setPending] = useState(false)


    // getting proviences list

    const getProvienceslist = async () => {

        const response = await getProviences()
        if (response && response.data.code == 1) {
            setProvience(response.data.provinces)

        } else {
            toast.error(response.data.message)
        }
    }



    useEffect(() => {
        getProvienceslist().then(setSelectedProvince(info.postcenters.province_id))
    },[])


    useEffect(() => {
        getCity().then(setSelectedCity(info.cities.id))
    },[selectedProvince])




    // getting city for selected province

    const [citylist, setCitylist] = useState(false)
    const [selectedCity, setSelectedCity] = useState(false)

    const getCity = async () => {


        const config = {
            params: {
                province_id: selectedProvince
            }
        }
        const response = await getCitylist(config)
        if (response && response.data.code == 1) {
            setCitylist(response.data.provinces)
        } else {
            toast.error(response.data.message)
        }


    }




    const handleEdit = async (values) => {
        const token = JSON.parse(localStorage.getItem('admin'))
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
        const conf = window.confirm('آیا  مطمن هستید ؟')
        if (conf) {
            const endpoint = `${url}/admin/postcenter/update/${info.postcenters.id}`


            const formdata = new FormData()
            formdata.append("name", values.name)
            formdata.append("username", values.username)
            formdata.append("password", values.password)
            formdata.append("tel", values.tel)
            formdata.append("address", values.address)
            formdata.append("province_id",selectedProvince)
            formdata.append("city_id",selectedCity)




            toast.info('در حال ارسال ...')
            const response = await axios.post(endpoint, formdata, config)
            if (response) {
                toast.dismiss()
                if (response.data.code === 1) {

                    toast.success('با موفقیت اضافه شد.');
                    setPending(false)


                } else {
                    toast.warning(response.data.error)
                }
            } else {
                toast.error('اتصال خود را بررسی کنید')
            }


        }

    }





    return (
        <React.Fragment>
            <button className=' yekan button  ' onClick={handleClickOpen}>

                    <Edit color='action'/>

            </button>
            <Dialog

                sx={{p:5}}
                PaperProps={{
                    sx:{
                        width: '69%' ,
                        p:4
                }
                }}

                fullScreen={true}
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >


                <h4>
                    ویرایش اطلاعات مربوط به دفتر
                    {' '}
                    {info.postcenters.name}
                </h4>


                <Formik initialValues={{
                    name: info.postcenters.name,
                    tel: info.postcenters.tel,
                    address: info.postcenters.address,
                    username: info.postcenters.username,
                    password: info.postcenters.password


                }}  onSubmit={(values, actions) => {
                    handleEdit(values);
                    actions.resetForm();
                }}>
                    {({errors, touched}) => (
                        <Form className=''>

                            <div className='columns is-multiline'>


                                <div className='column is-6'>
                                    <label className='label mt-3 yekan'>انتخاب استان</label>
                                    <Field className='select yekan width100' as="select"
                                           value={selectedProvince}
                                           onChange={(e) => {
                                               setCitylist(false)
                                               setSelectedProvince(e.target.value);
                                           }}>
                                        <option disabled label="انتخاب کنید"/>

                                        {
                                            provience == false ?
                                                <>
                                                    <Spinner/>
                                                </>
                                                :
                                                provience.map((item) => (
                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                ))
                                        }
                                    </Field>

                                </div>

                                <div className='column is-6'>
                                    <label className='label mt-3 yekan' >انتخاب شهر</label>
                                    <Field disabled={selectedProvince == false} className='select yekan width100'
                                           as="select"
                                           value={selectedCity}


                                           onChange={(e) => {
                                               setSelectedCity(e.target.value);
                                           }}>
                                        <option disabled label="انتخاب کنید"/>

                                        {
                                            citylist == false ?
                                                <>
                                                    <Spinner/>
                                                </>
                                                :
                                                citylist.map((item) => (
                                                    <option  key={item.id} value={item.id}>{item.name}</option>
                                                ))
                                        }
                                    </Field>

                                </div>

                                <div className='column is-6'>
                                    <label className='label mt-3 yekan' aria-hidden="true">نام مرکز </label>
                                    <Field className='yekan input my-2' type="text" id="name" name="name"/>
                                    <ErrorMessage component='span' className='has-text-danger yekan mx-auto'
                                                  name='name'/>
                                </div>

                                <div className='column is-6'>
                                    <label className='label mt-3 yekan' aria-hidden="true">تلفن مرکز </label>
                                    <Field className='yekan input my-2' type="text" id="tel" name="tel"/>
                                    <ErrorMessage component='span' className='has-text-danger yekan mx-auto'
                                                  name='tel'/>
                                </div>


                                <div className='column is-12'>
                                    <label className='label mt-3 yekan' aria-hidden="true">آدرس مرکز </label>
                                    <Field className='yekan input my-2' type="text" id="address" name="address"/>
                                    <ErrorMessage component='span' className='has-text-danger yekan mx-auto'
                                                  name='address'/>
                                </div>


                                <div className='column is-6'>
                                    <label className='label mt-3 yekan' aria-hidden="true">نام کاربری مرکز </label>
                                    <Field className='yekan input my-2' type="text" id="username" name="username"/>
                                    <ErrorMessage component='span' className='has-text-danger yekan mx-auto'
                                                  name='username'/>
                                </div>

                                <div className='column is-6'>
                                    <label className='label mt-3 yekan' aria-hidden="true">رمز عبو ر مرکز
                                    </label>
                                    <Field className='yekan input my-2' type="text" id="password" name="password"/>
                                    <ErrorMessage component='span' className='has-text-danger yekan mx-auto'
                                                  name='password'/>
                                </div>


                            </div>


                            <div className='has-text-centered py-6'>
                                {
                                    pending ? <Spinner/> : <button
                                        className='button clrtwo has-text-white has-text-weight-bold  pinar mt-6 mx-3 borderrad1 '
                                        type='submit'> اضافه کن
                                    </button>
                                }


                            </div>


                        </Form>


                    )}


                </Formik>

            </Dialog>
        </React.Fragment>
    );
}

